export default {
  nodes: [
    {
      id: '1',
      name: '初级程序员',
      conf: [],
    },
    {
      id: '2',
      name: '中级程序员',
      conf: [],
    },
    {
      id: '3',
      name: '高级程序员',
      conf: [],
    },
    {
      id: '4',
      name: '技术专家/架构师/咨询顾问',
      conf: [],
    },
    {
      id: '5',
      name: '技术经理',
      conf: [],
    },
    {
      id: '6',
      name: '技术总监/CTO',
      conf: [],
    },
    {
      id: '7',
      name: '产品经理',
      conf: [],
    },
    {
      id: '8',
      name: '产品总监',
      conf: [],
    },
  ],
  edges: [
    {
      source: '1',
      target: '2',
    },
    {
      source: '2',
      target: '3',
    },
    {
      source: '3',
      target: '4',
    },
    {
      source: '3',
      target: '5',
    },
    {
      source: '3',
      target: '7',
    },
    {
      source: '5',
      target: '6',
    },
    {
      source: '7',
      target: '8',
    },
  ],
};